import type { ClientOnboardingStatus } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { ONBOARDING_PARAMS } from '@/configs/version';
import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useSharedAppApi } from '@/features/api/hooks/shared-app/useSharedAppApi';
import { useAuth } from '@/features/authorization/provider/useAuth';

export const useGetOnboardingStatus = () => {
  const queryClient = useQueryClient();

  const { isAuthenticated } = useAuth();
  const api = useSharedAppApi();

  const handleSelect = useCallback(
    (status: ClientOnboardingStatus) => {
      queryClient.setQueryData([API_CACHE_KEYS.FEATURES], status.features);
      queryClient.setQueryData([API_CACHE_KEYS.PERSON], status.ownPerson);
      if (status?.homeGeoArea?.id) {
        queryClient.setQueryData(
          [API_CACHE_KEYS.GEO_AREA, status.homeGeoArea.id],
          status.homeGeoArea
        );
        queryClient.setQueryData(
          [API_CACHE_KEYS.GEO_AREA_PROFILE, status.homeGeoArea.id],
          status.homeGeoAreaProfile
        );
      }
      queryClient.setQueryData(
        [API_CACHE_KEYS.SELECTED_GEO_AREAS],
        status.selectedGeoAreas
      );
      queryClient.setQueryData(
        [API_CACHE_KEYS.LEGAL_TEXT_STATUS],
        status.legalTextStatus
      );

      return status;
    },
    [queryClient]
  );

  return useQuery({
    queryKey: [API_CACHE_KEYS.ONBOARDING_STATUS, { ONBOARDING_PARAMS }],
    queryFn: () => api.getOnboardingStatus1(ONBOARDING_PARAMS),
    enabled: isAuthenticated,
    retry: 1,
    refetchOnWindowFocus: false,
    select: handleSelect
  });
};
